import { Injectable } from '@angular/core';
import { FormGroup, Validators, FormControl, ValidatorFn, ValidationErrors, AbstractControl } from '@angular/forms';
import {
  FormInputBase,
  TextboxInput,
  DropdownInput,
  DatepickerInput
} from './../models/form-input.model';
import { validationMax } from '@constants/index';

@Injectable()
export class FormInputControlService {
  constructor() { }

  public toFormGroup(inputs: FormInputBase<string>[]): FormGroup {
    const formGroup: any = {};

    inputs.forEach((inputElement) => {
      let validator = [];
      if (inputElement.required) {
        validator = [Validators.required];
      }
      if (inputElement.type === 'number' && inputElement.isPercentage) {
        validator = [
          ...validator,
          Validators.min(0),
          Validators.max(validationMax.percentage),
        ];
      } else if (inputElement.type === 'number') {
        validator = [...validator, Validators.min(0)];
      }

      if (inputElement.isMonth) {
        validator = [...validator, Validators.max(12)];
      }

      if (inputElement.isNotDecimal) {
        validator = [...validator, this.roundedValueValidator()];
      }

      formGroup[inputElement.key] = new FormControl(
        inputElement.value,
        validator
      );
    });
    return new FormGroup(formGroup);
  }

  public getAllInputs(fieldConstants): FormInputBase<string>[] {
    const formInputs: FormInputBase<string>[] = [];
    if (fieldConstants && fieldConstants.length > 0) {
      fieldConstants.forEach((formElement) => {
        if (formElement.controlType === 'textbox') {
          formInputs.push(new TextboxInput(formElement));
        } else if (formElement.controlType === 'dropdown') {
          formInputs.push(new DropdownInput(formElement));
        } else if (formElement.controlType === 'datepicker') {
          formInputs.push(new DatepickerInput(formElement));
        }
      });
    }
    return formInputs.sort((a, b) => a.order - b.order);
  }
  public getInputNumericKeys(formInputs): string[] {
    const numericKeys = [];
    formInputs.forEach((input) => {
      if (input.type && input.type === 'number') {
        numericKeys.push(input.key);
      }
    });
    return numericKeys;
  }

  public formatData(data, numericKeys, isPost = false): any {
    for (const [key, value] of Object.entries(data)) {
      if (numericKeys.indexOf(key) > -1 && isPost) {
        data[key] = value ? +value : 0;
      } else if (numericKeys.indexOf(key) > -1 && !isPost) {
        data[key] = parseFloat(data[key]).toFixed(2);
      }
    }
    return data;
  }

  public roundedValueValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const isDecimal = +control.value % 1 !== 0 ? true : false;
      return isDecimal ? { isDecimal } : null;
    };
  }
}
